import { NgIf } from '@angular/common';
import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { GtmService } from '../../../../../core/services/gtm/gtm.service';
import { WindowRefService } from '../../../../../core/services/windowRef/window-ref.service';
import { FavouritesService } from '../../../../../favourites/services/favourites.service';

@Component({
    selector: 'favourites-counter',
    templateUrl: './favourites-counter.html',
    imports: [RouterLink, NgIf],
})
export class FavouritesCounterComponent implements OnInit, OnDestroy {
    @Input() listenerName: string;
    @Input() sportName: string;
    private gtmService = inject(GtmService);
    count: number;
    isAvailable: boolean = false;

    constructor(
        private favouritesService: FavouritesService,
        public windowRef: WindowRefService,
    ) {
        this.initCounter = this.initCounter.bind(this);
    }

    ngOnInit() {
        this.favouritesService.showFavourites().subscribe((show: boolean) => {
            this.isAvailable = show;
            if (this.isAvailable) {
                this.initCounter(this.listenerName, true);
            }
        });
    }

    ngOnDestroy() {
        if (this.isAvailable) {
            this.favouritesService.removeCountListener(this.listenerName);
        }
    }

    iconClicked() {
        this.windowRef.document.getElementById('icon')!.classList.add('fav-icon-active');
        this.setGtmData();
    }

    iconClickRemove() {
        this.windowRef.document.getElementById('icon')!.classList.add('fav-icon-inactive');
    }

    /**
     * initCounter()
     * @param {string} listenerName
     * @param {boolean} initRefresh
     */
    initCounter(listenerName: string, initRefresh: boolean = false) {
        this.favouritesService.countListener(listenerName, initRefresh).then(
            (count) => {
                this.count = count;
                this.initCounter(listenerName);
            },
            (error) => {
                console.warn(error);
                this.initCounter(listenerName);
            },
        );
    }

    /**
     * set GA tracking object
     * @param gtmEventLabel string value
     */
    setGtmData(): void {
        const gtmData = {
            eventCategory: 'navigation',
            eventAction: 'main',
            eventLabel: 'favourites',
            location: this.listenerName,
        };
        this.gtmService.push('trackEvent', gtmData);
    }
}
